/**
 * UserProfile - Shows logged-in user and sign-out button
 *
 * Displays user information and provides logout functionality
 * Requirement: ES-REQ-057 (Authentication Panel)
 */

import React from 'react';
import styled from 'styled-components';
import { useLabeling } from '@/context/labelingContext';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: var(--bg-card);
  border-bottom: 1px solid #e0e0e0;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: var(--text-dark);
`;

const UserEmail = styled.div`
  font-size: var(--font-size-base);
  color: var(--text-muted);
  margin-top: 2px;
`;

const LogoutButton = styled.button`
  padding: 8px 16px;
  background-color: var(--interactive-error);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--interactive-error-hover);
  }

  &:active {
    background-color: var(--color-error-700);
  }
`;

export const UserProfile: React.FC = () => {
  const { state, logout } = useLabeling();

  if (!state.user) {
    return null;
  }

  return (
    <Container>
      <UserInfo>
        <UserName>{state.user.name}</UserName>
        <UserEmail>{state.user.email}</UserEmail>
      </UserInfo>
      <LogoutButton onClick={logout}>
        Sign Out
      </LogoutButton>
    </Container>
  );
};

export default UserProfile;
